import { NgModule } from '@angular/core';

import { DetachedRouterOutlet } from './detached-router-outlet/detached-router-outlet.component';

@NgModule({
  imports: [DetachedRouterOutlet],
  exports: [DetachedRouterOutlet],
})
export class DetachedRouterModule {}
